import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { LiquidacionesPolizaCredito, PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { PolizaCreditoListComponent } from './poliza-credito-list.component';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { consts } from '../../../consts';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActualSelected } from '../../../shared/utils';

@Component({
    selector: 'convfact-poliza-credito-liquidaciones',
    templateUrl: './poliza-credito-dialog-liquidaciones.component.html',
    styleUrls: ['./poliza-credito.component.css'],
    standalone: false
})
export class PolizaCreditoDialogLiquidacionesComponent implements OnInit {

  public polizaCredito: PolizaCredito = this.data.polizaCredito;

  public liquidacionesPolizaCredito: LiquidacionesPolizaCredito = {
    uid: '0',
    polizaCreditoId: '',
    fecha: new Date(),
    concepto: '',
    importe: 0,
    comisiones: 0,
    activitiesUid: consts.EMPTY_GUID,
    activitiesName: '',
  };

  public saved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public dataSource: LiquidacionesPolizaCredito[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'importe', title: 'Importe', cell: (row) => `${row.importe}  `, class: (row) => `` },
    { field: 'concepto', title: 'Concepto', cell: (row) => `${row.concepto}  `, class: (row) => `` }
  ];

  private changesAtModal: boolean = false;

  public activities: ActivityModel[] = [];

  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PolizaCreditoListComponent>,
    public polizaCreditoService: PolizaCreditoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
    private cdr: ChangeDetectorRef,
    private masterService: MasterService,
  ) { }

  public ngOnInit(): void {

    this.ready = false;

    this.activityService.getList()
      .then(response => {
        this.activities = response;
      });

      this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
            this.isProjectEnable = activity.isProject;
          });

       //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects=data;
      this.cdr.detectChanges();
    })

    //Expense Project Types
    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes=data;
      this.cdr.detectChanges();
    })

    this.getData();
  }

  public save(): void {
  this.liquidacionesPolizaCredito.polizaCreditoId = this.polizaCredito.uid;

  let noError: boolean = true;

  // Validaciones básicas
  if (!this.liquidacionesPolizaCredito.fecha ||
      !this.liquidacionesPolizaCredito.concepto ||
      !this.liquidacionesPolizaCredito.importe ||
      !this.liquidacionesPolizaCredito.activitiesUid) {
    noError = false;
  }

  if (!noError) {
    this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    return;
  }

  this.changesAtModal = true;

  const request = this.isEditMode
    ? this.polizaCreditoService.liquidacionesUpdate(this.liquidacionesPolizaCredito)
    : this.polizaCreditoService.liquidacionesCreate(this.liquidacionesPolizaCredito);

  request
    .then(() => this.saved = true)
    .catch(() => this.displayInfo("Ha ocurrido un error al guardar la liquidación"));
}



  public getData(): void {
    this.saved = false;
    this.ready = false;

    this.polizaCreditoService.liquidacionesList(this.polizaCredito.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;

          if(this.isEditMode){
            const element= this.dataSource[0];
            this.liquidacionesPolizaCredito= {... element};

            if(element.projectUid){
              const projectFound= this.projects.find(p=> p.id === element.projectUid);
              this.liquidacionesPolizaCredito.projectUid= projectFound ? projectFound.id :null;
            }
            if(element.expenseProjectTypeUid){
              const expenseFound= this.expenseProjectTypes.find(p=> p.id === element.expenseProjectTypeUid);
              this.liquidacionesPolizaCredito.expenseProjectTypeUid= expenseFound ? expenseFound.id :null;
            }
          }
        }
        this.ready = true;
      })
      .catch(error => {
        this.ready = true;
      });
  }

  public delete(uidElement: string): void {
    this.changesAtModal = true;

    // Este uid es el id
    this.polizaCreditoService.liquidacionesDelete(uidElement)
      .then(response => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar la liquidación");
      });
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid == uidElement);

    this.isEditMode = true;
    this.saved = false;

    this.liquidacionesPolizaCredito = elementSearched;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close(this.changesAtModal);
  }
  public trackByIndex(i: number) { return i; }

}
